import { toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { oktaAuthClient } from '@app/components/LoginWidget/config';

export const SecurityLayout: React.FC = () => {
  const history = useNavigate();
  const restoreOriginalUri = async (): Promise<void> => {
    history(
      toRelativeUrl(
        '/chats',
        window.location.origin,
      ),
      { replace: true },
    );
  };

  return (
    <Security className="security" oktaAuth={oktaAuthClient} restoreOriginalUri={restoreOriginalUri}>
      <Outlet />
    </Security>
  );
};
